<h5 mat-dialog-title>{{title}}</h5>

<mat-dialog-content>
  {{message}}
</mat-dialog-content>

<mat-dialog-actions>
  <div type="submit" class="button button--filled" (click)="close()">Close</div>
</mat-dialog-actions>
